import * as amplitude from "@amplitude/analytics-browser";
import { useDisclosure } from "@chakra-ui/react";
import { RiHeart3Line } from "react-icons/ri";
import { SavedViewFormType } from "src/hooks/useSavedViews";
import { ManageSavedViewDialog } from "../Dialogs/ManageSavedViewDialog";
import { NavItem } from "../Navigation";

interface SaveViewButtonProps {
  onSave: (savedView: SavedViewFormType) => void;
  formTemplateName: string;
}

export const SaveViewButton = ({
  onSave,
  formTemplateName,
}: SaveViewButtonProps) => {
  const { onOpen, onClose, isOpen } = useDisclosure();

  return (
    <>
      <NavItem
        label="Save view"
        onClick={() => {
          amplitude.track("Clicked Save view", {
            form_name: formTemplateName,
          });
          onOpen();
        }}
        leadIcon={RiHeart3Line}
        styleProps={{
          borderStyle: "dashed",
          colorScheme: "gray",
          color: "gray.600",
        }}
      />
      <ManageSavedViewDialog
        isOpen={isOpen}
        onCancel={onClose}
        onSave={onSave}
      />
    </>
  );
};
